import React from 'react'

interface FactContentCellProps {
  facts: Array<string>
}

export const FactContentCell: React.FC<FactContentCellProps> = ({ facts }) => {
  /**
   * This function is not ideal. It just recognises the IDs and labels in a fact and highlights them.
   * Finding an ideal solution for this is a work in progress. So until then, we will keep using
   * regex and assume IDs to start with # and labels to be wrapped in inverted commas.
   *
   * FYI: If ever we changed the pattern in the Facts template, this function will need to be updated.
   */
  const hightlightFactContent = (text: string): React.ReactNode => {
    const splitText = text.split(/(#[\w-]+|"[^"]*"|\n)/)

    return splitText.map((part, index) => {
      // Convert newline character to visual line break
      if (part === '\n') {
        return <br key={`break-${index}`} />
      }

      // Facts have IDs with '#' in the start. This is a pattern that we added to differentiate identifiers from other text.
      // So we need to highlight the text that starts with '#' as an ID.
      if (/^#[\w-]+$/.test(part)) {
        return (
          <span key={`id-${index}`} className="font-medium">
            {part.slice(1)}
          </span>
        )
      }

      // Facts have titles/labels wrapped with inverted commas "", this is a pattern that we added to differentiate identifiers from other text.
      if (/^"[^"]*"$/.test(part)) {
        return (
          <span key={`quote-${index}`} className="text-gray-600 font-medium">
            {part.slice(1, part.length - 1)}
          </span>
        )
      }

      return part
    })
  }
  const FactsList = (): JSX.Element => {
    if (facts.length > 1) {
      return (
        <ul className="list-disc list-inside space-y-1 text-left">
          {facts.map((item, index) =>
            item !== '' ? (
              <li key={index} className="text-sm leading-relaxed text-gray-700">
                {hightlightFactContent(item)}
              </li>
            ) : null
          )}
        </ul>
      )
    } else {
      return <div className="text-sm leading-relaxed text-left text-gray-700">{hightlightFactContent(facts[0])}</div>
    }
  }

  return <FactsList />
}

FactContentCell.displayName = 'FactContentCell'
